// @flow

import {combineReducers} from 'redux';
import Layout from '../modules/ui/layouts/redux/layout/reducers';
import Auth from '../modules/auth/redux/reducers';
import AppMenu from '../modules/ui/components/AppMenu/redux/reducers';
import {apiKey, billing, subscription} from '../modules/settings/redux';
import UI from '../modules/ui/redux/reducers';
import {reducers as Templates, templateReducers as TemplateCore} from '../modules/templates/redux';
import {
    dependentDocument,
    documentDetailReducers as DocumentCore,
    linkedDocument,
    reducers as Document
} from '../modules/documents/redux';
import {reducers as Scan, scanReducers as ScanCore} from '../modules/scan/redux';
import Notification from '../modules/ui/components/NotificationDropdown/redux/reducers';
import {generalSettingsReducers as GeneralSettings} from '../modules/settings/redux/reducers';
import {folder, group, user} from '../modules/users/redux';
import {
    documentAuditTrailReport,
    invoiceReport,
    masterViewReport,
    ReportReducers as ReportCore,
    statisticReport,
    userAuditTrailReport,
    userManagementReport,
    massUpdate,
} from '../modules/report/redux';
import {masterDataReducers as MasterDataCore, reducers as MasterView} from '../modules/settings/master-data/redux';
import {dashboardReducers} from '../modules/dashboard/redux';

// setting big module
const ApiKey = apiKey.reducers;
const Subscription = subscription.reducers;
const Billing = billing.reducers;

// user big module
const Users = user.reducers;
const UserCore = user.userReducers;

const Groups = group.reducers;
const GroupCore = group.groupReducers;

const Folder = folder.reducers;

// reports reducers
const StatisticReportReducer = statisticReport.reducers;
const InvoiceReportReducer = invoiceReport.reducers;
const UserManagementReportReducer = userManagementReport.reducers;
const UserAuditTrailReportReducer = userAuditTrailReport.reducers;
const MasterViewReportReducer = masterViewReport.reducers;
const DocumentAuditTrailReportReducer = documentAuditTrailReport.reducers;

// document
const DependentDocumentReducer = dependentDocument.reducers;
const LinkedDocumentReducer = linkedDocument.reducers;
const MassUpdateReducer = massUpdate.reducers;

const Dashboard = dashboardReducers;

export default combineReducers({
    Auth,
    AppMenu,
    Layout,
    ApiKey,
    Subscription,
    Billing,
    Users,
    UserCore,
    Groups,
    GroupCore,
    UI,
    Templates,
    TemplateCore,
    Document,
    DocumentCore,
    DependentDocumentReducer,
    LinkedDocumentReducer,
    Scan,
    ScanCore,
    Notification,
    GeneralSettings,
    Folder,
    MasterView,
    MasterDataCore,
    ReportCore,
    StatisticReportReducer,
    InvoiceReportReducer,
    UserManagementReportReducer,
    UserAuditTrailReportReducer,
    MasterViewReportReducer,
    DocumentAuditTrailReportReducer,
    Dashboard,
    MassUpdateReducer,
});
